import { Event as HotjarEvent } from "@modules/core/hotjar/types";
import { AppraisalSource } from "@modules/appraisal/types/AppraisalSource";
import TradeInSourceName from "@modules/trade/enums/TradeInSourceName";
import { AppraisalPageDataPayload } from "@modules/trade/types/AppraisalPageMode";
import { AppraisalPayloadSourceParams } from "@modules/trade/types/AppraisalSourceParams";
import SourceEnum from "@common/enums/SourceEnum";

const knownSources: Record<TradeInSourceName, AppraisalSource> = {
  [TradeInSourceName.RightRide]: {
    id: SourceEnum.RightRide,
    name: "unknown",
    isKnownSource: false,
    allowedSourceOrigins: [],
    allowedMethods: [],
  },
  [TradeInSourceName.Kijiji]: {
    id: SourceEnum.Kijiji,
    name: TradeInSourceName.Kijiji,
    isKnownSource: true,
    allowedSourceOrigins: process.env.KIJIJI_ICO_ORIGINS
      ? (process.env.KIJIJI_ICO_ORIGINS as string).replace(/\s/g, "").split(",")
      : [],
    allowedMethods: ["ico", "value-estimate"],
    eventProperties: {
      hotjarEvent: HotjarEvent.KijijiIcoTradeIn,
    },
  },
  [TradeInSourceName.AutoCanadaDealer]: {
    id: SourceEnum.AutoCanadaDigital,
    name: TradeInSourceName.AutoCanadaDealer,
    isKnownSource: true,
    allowedSourceOrigins: process.env.AUTOCANADA_ICO_ORIGINS
      ? (process.env.AUTOCANADA_ICO_ORIGINS as string).split(",")
      : [],
    allowedMethods: ["ico", "value-estimate"],
    eventProperties: {
      hotjarEvent: HotjarEvent.AutoCanadaIcoTradeIn,
    },
  },
  [TradeInSourceName.Throttle]: {
    id: SourceEnum.Throttle,
    name: TradeInSourceName.Throttle,
    isKnownSource: true,
    allowedSourceOrigins: process.env.THROTTLE_ICO_ORIGINS
      ? (process.env.THROTTLE_ICO_ORIGINS as string)
          .replace(/\s/g, "")
          .split(",")
      : [],
    allowedMethods: ["ico"],
    eventProperties: {
      hotjarEvent: HotjarEvent.ThrottleIcoTradeIn,
    },
  },
};

const getSourceDetails = (source: TradeInSourceName): AppraisalSource => {
  const appraisalSource = knownSources[source] ?? {
    name: "unknown",
    isKnownSource: false,
    allowedSourceOrigins: [],
    allowedMethods: [],
  };

  if (appraisalSource.isKnownSource) {
    appraisalSource.allowedSourceOrigins.push(
      process.env.HOSTED_ICO_TEST_URL as string
    );
  }

  // since our test environment doesnt actually run on a server just allow all instead of an implicit origin
  // this is temporary until we have our sandbox setup.
  if (
    appraisalSource.isKnownSource &&
    (process.env.NEXT_PUBLIC_ENV_NAME === "local" ||
      process.env.NEXT_PUBLIC_ENV_NAME === "qa")
  ) {
    appraisalSource.allowedSourceOrigins.push("*");
  }

  return appraisalSource;
};

export const convertSourceParams = (
  payload: AppraisalPageDataPayload
): AppraisalPayloadSourceParams => {
  return {
    ...payload,
    adId: payload.adId ? String(payload.adId) : undefined,
    userId: payload.userId ? String(payload.userId) : undefined,
    sessionId: payload.sessionId ? String(payload.sessionId) : undefined,
    appId: payload.appId ? String(payload.appId) : undefined,
    locationId: payload.locationId ? String(payload.locationId) : undefined,
    ctaId: payload.ctaId ? String(payload.ctaId) : undefined,
    leadSubSource: payload.leadSubSource
      ? String(payload.leadSubSource)
      : undefined,
  };
};

export default getSourceDetails;
